import { httpRequest } from '@/utils/umiRequest';
import { LogItem } from './index.d';


// 邮件工单日志-列表-需要分页
export const getEmailDisputeLogs = async (id: string | number) => {
  return await httpRequest.get<LogItem[]>(`/email-ticket-logs/${id}`);
};
